import {
  APP_INITIALIZER,
  ApplicationConfig,
  LOCALE_ID,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter } from '@angular/router';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
// AuthInterceptor (solcre-org/core) replaced by TokenInterceptor
import { LocalStorageUtility } from '@solcre-org/core';
import { TokenInterceptor } from './core/interceptors/token.interceptor';
import { ConflictInterceptor } from './core/interceptors/conflict.interceptor';
import {
  CacheBustingInterceptor,
  provideCoreUiTranslateLoader,
  provideTranslateLoader,
} from '@solcre-org/core-ui';

import '@angular/common/locales/global/es'; // o 'es'

import { routes } from './app.routes';
import { environment } from '../environments/environment.local';
import { InitializerService } from './shared/services/initializer.service';
import { Observable } from 'rxjs';

export function init_admins(
  initializer: InitializerService
): () => Observable<any> {
  LocalStorageUtility.setPrefix('kma-ui');
  initializer.setLoginState(environment.STATES.LOGIN);
  return () => initializer.init();
}

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideCoreUiTranslateLoader({
      projectPath: './assets/i18n/',
      projectFileName: 'main.json',
      corePath: './assets/i18n/',
      coreFileName: 'common.json',
    }),
    provideHttpClient(withInterceptorsFromDi()),
    {
      provide: APP_INITIALIZER,
      useFactory: init_admins,
      deps: [InitializerService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      // useClass: AuthInterceptor, // AuthInterceptor (solcre-org/core) replaced by TokenInterceptor
      useClass: TokenInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ConflictInterceptor,
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CacheBustingInterceptor,
      multi: true,
    },
    { provide: LOCALE_ID, useValue: 'es' },
  ],
};
